var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    name: 'CAR_TRAIN',
    query: {
        seriesName: _vm.carInfo.series_name
    },
    params: {
        serid: _vm.carInfo.series_id
    }}}},[(_vm.type === 'img')?_c('img',{directives:[{name:"real-src",rawName:"v-real-src",value:(_vm.carInfo.img),expression:"carInfo.img"}],staticClass:"car-img",attrs:{"src":require("@/assets/images/bitmap-small.png")}}):_c('p',{staticClass:"car-name-in"},[_vm._v(_vm._s(_vm.carInfo.series_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }